import { makeStyles } from '@material-ui/styles';

const TABS_HEADER_DESKTOP_HEIGHT = 60;
const TABS_HEADER_MOBILE_HEIGHT = 35;

export default makeStyles(theme => ({
  container: {
    backgroundColor: theme.palette.colors.white,
    width: '100%',
    height: '100%',
    [theme.breakpoints.up('mobile')]: {
      display: 'flex',
      justifyContent: 'center',
      height: 'unset',
    },
  },
  paper: {
    width: '100%',
    height: '100%',
    [theme.breakpoints.up('mobile')]: {
      minWidth: 800,
      maxWidth: 1280,
      margin: theme.spacing(4),
      border: [1, 'solid', theme.palette.colors.border],
      display: 'flex',
    },
  },
  rightBar: {
    borderRight: [1, 'solid', theme.palette.colors.border],
  },
  content: {
    paddingTop: 10,
    width: '100%',
    height: '100%',
  },
  calculator: {
    width: '100%',
    height: `calc(100% - ${TABS_HEADER_MOBILE_HEIGHT}px)`,
    [theme.breakpoints.up('mobile')]: {
      height: 'unset',
    },
  },
  tabs: {
    height: TABS_HEADER_MOBILE_HEIGHT,
    boxShadow: '0px 2px 2px rgba(50, 50, 71, 0.06), 0px 2px 4px rgba(50, 50, 71, 0.06)',
    zIndex: 90,
    padding: [0, 28, 0, 28],
    [theme.breakpoints.up('mobile')]: {
      height: TABS_HEADER_DESKTOP_HEIGHT,
      padding: [22, 28, 0, 28],
    },
  },
  tab: {
    minWidth: 'unset',
    marginRight: 32,
  },
  buttonContainer: {
    backgroundColor: 'transparent',
    position: 'fixed',
    bottom: 5,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  button: {
    margin: 5,
    boxShadow: '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)',
    borderRadius: 40,
    padding: [12, 24],
  },
}));



// WEBPACK FOOTER //
// ./src/components/Calculators/useStyles.js